export enum EXPERIMENT_VARIATIONS {
  ORIGINAL = 'original',
  VARIANT = 'variant',
  VARIANT_ONE = 'variant_1',
  VARIANT_TWO = 'variant_2',
  VARIANT_THREE = 'variant_3',
  VARIANT_FOUR = 'variant_4',
  VARIANT_FIVE = 'variant_5',
}

export const OPTIMIZELY_DATA_LOCALSTORAGE_KEY = 'optly_data';

// Experiment Keys
export const MAGIC_LINK_FLOW_EXPERIMENT = 'magic-link-flow02';
export const PASSWORD_LESS_SIGNUP_EXPERIMENT = 'passwordless-signup';
export const FLYOUT_BUSINESS_PERSONAL_CONTEXT_EXPERIMENT = 'flyout-context';
export const CART_PAGE_NEW_LAYOUT = 'cart_page_new_layout_v2';
export const PRODUCT_TYPES_EXPERIMENT_KEY = 'product_type_searches';
export const CATEGORY_NAVIGATION_REDESIGN = 'maco_redesign_of_the_navigation';
export const ZRP_RECOMMENDATIONS_FOR_YOU = 'zrp_recommendations_for_you';
